import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DynamicComponentDirective } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { AccountMenuItemBase } from '../account-menu-item-base';
import { AccountMenuScrollService } from '../account-menu-scroll.service';

@Component({
    imports: [CommonModule, DynamicComponentDirective, IconCustomComponent],
    selector: 'vn-am-header',
    templateUrl: 'header.html',
})
export class HeaderComponent extends AccountMenuItemBase implements OnInit {
    private accountMenuScrollService = inject(AccountMenuScrollService);

    scrolled: boolean;
    template: number;
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit() {
        this.accountMenuScrollService.scroll.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((pos) => {
            this.scrolled = pos > 0;
        });
    }

    close() {
        this.accountMenuService.toggle(false, {
            closedWithButton: true,
        });
    }
}
